import React from 'react'
import { Column } from 'primereact/column'
import { ColumnGroup } from 'primereact/columngroup'
import { Row } from 'primereact/row'
import { useIntl } from 'react-intl'
import useHandlerBasicActions from '../../../utils/hooks/useHandlerBasicActions'
import DataTableComp from '../data-table/DataTableComp'
import MainCommonView from '../MainCommonView'
import { bodyCheckbox } from '../data-table/column-types/ColumnTypes'
import './usersAccessModule.scss'

const UsersAccessModule = ({ getService }) => {
  const { formatMessage: msg } = useIntl()

  const dataFacade = useHandlerBasicActions({
    getAll: getService,
    sortFieldInitial: 'name',
    rowsPerPageInitial: 1,
  })

  const renderGroup = (groups) => {
    return groups.map((group) => {
      return <li className="li-permissions">{msg({ id: group?.group })}</li>
    })
  }

  const renderPermissions = (groups, permissions) => {
    return groups.map((group) => {
      return (
        <li className="li-permissions">
          {bodyCheckbox(group.permissions[permissions])}
        </li>
      )
    })
  }

  const headerOptions = {
    searchOptions: dataFacade?.searchOptions,
  }

  const pagerOptions = {
    ...dataFacade?.pagerOptions,
    totalRecords: dataFacade?.data?.total,
  }

  const headerGroup = (
    <ColumnGroup>
      <Row>
        <Column header={msg({ id: 'name' })} rowSpan={2} />
        <Column header={msg({ id: 'role' })} rowSpan={2} />
        <Column header={msg({ id: 'group' })} rowSpan={2} />
        <Column header={msg({ id: 'permissions' })} colSpan={4} />
      </Row>
      <Row>
        <Column header={msg({ id: 'create' })} />
        <Column header={msg({ id: 'edit' })} />
        <Column header={msg({ id: 'view' })} />
        <Column header={msg({ id: 'delete' })} />
      </Row>
    </ColumnGroup>
  )

  const dataTable = (
    <DataTableComp
      tableOptions={{
        value: dataFacade?.data?.resp,
        size: 'small',
        headerColumnGroup: headerGroup,
        ...dataFacade?.sortOptions,
      }}
      columns={[
        <Column field="name" header={msg({ id: 'name' })} sortable />,
        <Column field="role" header={msg({ id: 'role' })} />,
        <Column
          field="groups"
          header={msg({ id: 'group' })}
          body={(rowData) => renderGroup(rowData.groups, 'group')}
        />,
        <Column
          field="groups"
          header={msg({ id: 'group' })}
          body={(rowData) => renderPermissions(rowData.groups, 'post')}
        />,
        <Column
          field="groups"
          header={msg({ id: 'group' })}
          body={(rowData) => renderPermissions(rowData.groups, 'patch')}
        />,
        <Column
          field="groups"
          header={msg({ id: 'group' })}
          body={(rowData) => renderPermissions(rowData.groups, 'get')}
        />,
        <Column
          field="groups"
          header={msg({ id: 'group' })}
          body={(rowData) => renderPermissions(rowData.groups, 'delete')}
        />,
      ]}
    />
  )

  return (
    <div className="users-access-form">
      <MainCommonView
        headerOptions={headerOptions}
        componentData={dataTable}
        pagerOptions={pagerOptions}
      />
    </div>
  )
}

export default UsersAccessModule
